function topic_earthquake(default_topic = 'cwb-source', scenario = false){
	var end_day_utc = get_now_time_utc_value() - (8 * 3600000),
		start_day_utc = end_day_utc - (30 * 24 * 3600000),
		start_day = UTCtoString_v2(start_day_utc),
		end_day = UTCtoString_v2(end_day_utc),
		earthquakeIntensityMapping = { "0級": 0, "1級": 1, "2級": 2, "3級": 3, "4級": 4, "5弱": 5, "5強": 5.5, "6弱": 6, "6強": 6.5, "7級": 7 },
		ncdrEarthquakeList = ajax_call(publicPath + '/napi/simulate/earthquakencdr').reverse(),
		ncdrEarthquakeFirst = ncdrEarthquakeList[0]

	if (scenario) {
		$('#scenario_content_earthquake').html(
			'<div>時間：' + ncdrEarthquakeFirst["event_id"].slice(2) + '</div>' +
			'<div>震央位置：[' + ncdrEarthquakeFirst["lat"] + ', ' + ncdrEarthquakeFirst["lon"] + ']</div>' +
			'<div>地震規模：<span class="r_text">' + ncdrEarthquakeFirst["mag"] + '</span></div>' +
			'<div>震源深度：' + ncdrEarthquakeFirst["depth"] + '公里</div>'
		)
		return
	}

	$("#home4 .card-body").html(
		slider_card_component_create({
			"cardhead": "監控資料追蹤",
			"cardbody": data_source_table_html("地震監控")
		}, false) +
		// tab
		`<ul id="topic-earthquake-ul" class="nav nav-tabs mt-10p" role="tablist">
			<li class="nav-item text-center" style="width:33%" id="cwa">
				<a class="nav-link" data-toggle="tab" href="#topic-earthquake-info-cwb-source" role="tab">中央氣象署</a>
			</li>
			<li class="nav-item text-center" style="width:33%" id="ncdr">
				<a class="nav-link" data-toggle="tab" href="#topic-earthquake-info-ncdr" role="tab">NCDR</a>
			</li>
			<li class="nav-item text-center" style="width:33%" id="one-click">
				<a class="nav-link" data-toggle="tab" href="#topic-earthquake-info-one-click" role="tab">一鍵通</a>
			</li>
		</ul>` +
		// tab content
		'<div class="tab-content mt-3 pb-3">' +
			// cwa content
			`<div class="tab-pane fade" role="tabpanel" id="topic-earthquake-info-cwb-source">
				<div class="input-group input-group-sm mb-2 pb-2 border-b-normal">
					<div class="input-group-prepend">
						<label class="input-group-text">選擇檢視類型</label>
					</div>
					<select class="custom-select" id="topic-earthquake-info-cwb-source-viwer">
						<option value="newest" selected>最新地震事件資訊</option>
						<option value="history">歷史地震事件查詢與檢視</option>
					</select>
				</div> 
				<div id="topic-earthquake-info-cwb-source-search-content" class="d-none">
					<h5 class="font-weight-bold mb-2"><i class="fas fa-calendar-alt mr-2"></i>地震事件查詢</h5>
					<div class="input-group input-group-sm">
						<div class="input-group-prepend">
							<span class="input-group-text">時段選擇</span>
						</div>
						<input type="text" class="form-control date-picker" id="topic-earthquake-info-cwb-source-date-start" value="${start_day.slice(0, 4)}-${start_day.slice(5, 7)}-${start_day.slice(8, 10)}">
						<input type="text" class="form-control date-picker" id="topic-earthquake-info-cwb-source-date-end" value="${end_day.slice(0, 4)}-${end_day.slice(5, 7)}-${end_day.slice(8, 10)}">
						<div class="input-group-append">
							<button type="button" class="btn btn-success" id="topic-earthquake-info-cwb-source-search-trig">查詢</button>
						</div>
					</div>
					<div id="topic-earthquake-info-cwb-source-event-table" class="mt-3"></div>
					<hr>
				</div>
				<div id="topic-earthquake-info-cwb-source-detailed-content"></div>
			</div>` +
			// 1click content
			`<div class="tab-pane fade" role="tabpanel" id="topic-earthquake-info-one-click">
				<p>
					本模組依「新北市地震廣域救災外部支援作業指南」規劃各縣市救災支援集結據點，
				   	分別為板橋第一體育場、頭前運動公園、三重綜合體育館、板樹體育館、錦和運動公園及
				  	國立體育大學綜合體育館停車場，用以整合各單位支援隊伍，協助各災區搶救。
				</p>
				<div class="input-group mb-2">
					<div class="input-group-prepend">
						<label class="input-group-text">選擇起始縣市</label>
					</div>
					<select class="custom-select" id="start-city">
						<option value="default-start-city" selected>選擇起始縣市</option>
					</select>
				</div>
				<div class="input-group mb-2">
					<div class="input-group-prepend">
						<label class="input-group-text">選擇起始地點</label>
					</div>
					<select class="custom-select" id="start-point">
						<option value="default-start-point" selected>選擇起始地點</option>
					</select>
				</div>
				<div class="input-group mb-2 pb-2 border-b-normal">
					<div class="input-group-prepend">
						<label class="input-group-text">預設目的地點</label>
					</div>
					<select class="custom-select" id="end-point">
						<option value="default-end-point" selected>預設目的地點</option>
					</select>
				</div>
				<p class="font-weight-bold">*為未簽訂協定縣市</p>

				<h6 class="mt-3 font-weight-bold"><i class="fas fa-table mr-2"></i>建議路線</h6>
				<div id="topic-earthquake-route-advice"><p>請先選擇起始縣市</p></div>
				<hr/>
				<h6 class="mt-3 font-weight-bold"><i class="fas fa-table mr-2"></i>公路局道路封閉列表</h6>
				<table class="table table-sm table-bordered mt-2">
					<thead class="thead-dark">
						<tr>
							<th>#</th>
							<th>行政區</th>
							<th>封閉路段</th>
							<th>封閉開始時間</th>
							<th>預計結束時間</th>
						</tr>
					</thead>
					<tbody id="road-break-thb-table" style="cursor:pointer"></tbody>
				</table>

				<h6 class="mt-3 font-weight-bold"><i class="fas fa-table mr-2"></i>EMIC災情案件道路影響列表</h6>
				<table class="table table-sm table-bordered mt-2">
					<thead class="thead-dark">
						<tr>
							<th>#</th>
							<th>封閉時間</th>
							<th>行政區</th>
							<th>事件位置</th>
						</tr>
					</thead>
					<tbody id="road-break-emic-table" style="cursor:pointer"></tbody>
				</table>

				<h6 class="mt-3 font-weight-bold"><i class="fas fa-table mr-2"></i>EMIS災情案件道路影響列表</h6>
				<table class="table table-sm table-bordered mt-2">
					<thead class="thead-dark">
						<tr>
							<th>#</th>
							<th>通報時間</th>
							<th>處理狀態</th>
							<th>事件位置</th>
						</tr>
					</thead>
					<tbody id="road-break-emis-table" style="cursor:pointer"></tbody>
				</table>

				<h6 class="mt-3 font-weight-bold"><i class="fas fa-link mr-2"></i>NCDR交通串流主題圖</h6>
				<ul>
					<li>說明：資料來源為TDX，整合國道、省道之即時資訊，供使用者查詢特定範圍內的車流情形，並搭配即時路況圖，皆可作為人員疏散撤離之參考依據。</li>
					<li>檢視：<a target="_blank" href="https://eocdss.ncdr.nat.gov.tw/web/ThemeMap/914969E5-A061-4860-A725-E45CDE8CB7F0?token=dvSsWoFJRwd6vZG3ndjM">連結</a></li>
				</ul>
			</div>` +
			// ncdr content
			`<div class="tab-pane fade" role="tabpanel" id="topic-earthquake-info-ncdr">
				<div class="input-group mb-2 pb-2 border-b-normal">
					<div class="input-group-prepend">
					<label class="input-group-text">選擇檢視類型</label>
					</div>
					<select class="custom-select" id="topic-earthquake-viwer">
						<option value="topic-earthquake-newest" selected>最新地震資訊</option>
						<option value="topic-earthquake-simulation">模擬震後初期評估檢視</option>
						<option value="topic-earthquake-history">歷史震後初期評估檢視</option>
					</select>
				</div> 
				<div class="pr-2" id="topic-earthquake-render-div"></div>
			</div>` +
		'</div>'
	)

	$('#one-click').click(() => { 
		loader_asynchronous(subtopic_1click) 
	})

	$('.date-picker').datepicker({
		format: 'yyyy-mm-dd',
		orientation: 'bottom'
	})

	$("#topic-earthquake-info-cwb-source-search-trig").click(function(){
		var list = []
		var tbodyHtml = ""
		var queryDate = { start: $("#topic-earthquake-info-cwb-source-date-start").val(), end: $("#topic-earthquake-info-cwb-source-date-end").val() }
		var urlMapping = {
			"newest": publicPath + "/napi/obs/cwa/ntc_intensity/earthquakenewest/data",
			"history": publicPath + `/napi/obs/cwa/ntc_intensity/earthquakenewest/data/${queryDate.start}/${queryDate.end}`
		}
		var viwerType = $("#topic-earthquake-info-cwb-source-viwer").val()
		var cwbData = ajax_call(urlMapping[viwerType])
		var searchPartStatus = $("#topic-earthquake-info-cwb-source-search-content").hasClass("d-none")
		switch (viwerType) {
			case "newest":
				if (!searchPartStatus) {
					$("#topic-earthquake-info-cwb-source-search-content").addClass("d-none")
				}
				break
			case "history":
				if (searchPartStatus) {
					$("#topic-earthquake-info-cwb-source-search-content").removeClass("d-none")
				}
				break
		}
		function findMaxIntensity(list){
			var earthquakeIntensityMapping = { "0": "0級", "1": "1級", "2": "2級", "3": "3級", "4": "4級", "5": "5弱", "5.5": "5強", "6": "6弱", "6.5": "6強", "7": "7級" }
			return earthquakeIntensityMapping[String(Math.max(...list))]
		}
		cwbData.forEach((el, index) => {
			el.data = JSON.parse(el.data)
			list.push({
				time: el.time,
				data: el.data,
				report_url: el.report_url
			})
			tbodyHtml += `
				<tr target-Index="${index}">
					<td>${el.time}</td>
					<td>${findMaxIntensity(el.data.map(o => earthquakeIntensityMapping[o["震度"]]))}</td>
				</tr>`
		})
		$("#topic-earthquake-info-cwb-source-event-table").html("")
		$("#topic-earthquake-info-cwb-source-event-table").html(`
			<table class="table table-sm table-pointer">
				<thead class="thead-dark">
					<tr>
						<th>發生時間</th>
						<th>最大震度</th>
					</tr>
				</thead>
				<tbody>${tbodyHtml}</tbody>
			</table>`
		)
		$("#topic-earthquake-info-cwb-source-event-table table").DataTable({"order": [[ 0, "desc" ]]})
		$("#topic-earthquake-info-cwb-source-event-table tbody").on("click", "tr", function(){
			renderCwbFtpEarthquakeInfo(list[Number($(this).attr("target-Index"))])
		})
		$("#topic-earthquake-info-cwb-source-event-table tbody tr").eq(0).click()
	})

	$("#topic-earthquake-info-cwb-source-viwer").change(function(){
		$("#topic-earthquake-info-cwb-source-search-trig").click()
	}).trigger("change")

	// 選擇頁籤：中央氣象署、一鍵通、NCDR
	$('a[href="#topic-earthquake-info-cwb-source"]').click(function(){
		topicChange("cwb")
	})
	$('a[href="#topic-earthquake-info-one-click"]').click(function(){
		topicChange("1click")
	})
	$('a[href="#topic-earthquake-info-ncdr"]').click(function(){
		topicChange("ncdr")
		renderTopicEarthquakeNewest()
	})
	// 預設頁籤：(依參數決定、地震模組預設是中央氣象署)
	$(`a[href="#topic-earthquake-info-${default_topic}"]`).click()
	
	$('#topic-earthquake-viwer').change(function(){
		var target = $(this).val()
		switch(target){
			case "topic-earthquake-newest":
				renderTopicEarthquakeNewest()
				break
			case "topic-earthquake-simulation":
				renderTopicEarthquakeHistory('simulation')
				break
			case "topic-earthquake-history":
				renderTopicEarthquakeHistory('history')
				break
		}
	})

	function topicChange(topicName){
		switch (topicName) {
			case "1click":
				$("#base_layer .leaflet-layerstree-children").find("input").eq(3).click();
				map.setView([23.772, 120.6], 8);
				$("#map_clear").click();
				break
			case "cwb":
				$("#base_layer .leaflet-layerstree-children").find("input").eq(3).click();
				map.setView([25.02650624267848, 121.38427731581034], 10)
				$("#map_clear").click();
				map.addLayer(overlay_dataset['cwb-ntpc-earthquake'])
				break
			case "ncdr":
				$("#base_layer .leaflet-layerstree-children").find("input").eq(5).click();
				map.setView([23.772, 120.6], 8)
				$("#map_clear").click();
				$("#legend_div_container").append(`
					<div class="legend_text" id="ndcr_main_layer">
						震度網格<br><img src="Legend/earthquake_pga_grid.jpg" width="100%">
					</div>
					<div class="legend_text">震央位置<br><img src="marker_icon/earthquake_center.png" width="32"></div>
					<div class="legend_text">重要橋梁<br><img src="marker_icon/bridge.png" width="32"></div>
					<div class="legend_text">醫護相關<br><img src="marker_icon/vulnerable.png" width="32"></div>
					<div class="legend_text">學校單位<br><img src="marker_icon/school.png" width="32"></div>
					<div class="legend_text">重要道路<br><img src="marker_icon/line_black.png" width="32"></div>
					<div class="legend_text">電力管線<br><img src="marker_icon/line_yellow.png" width="32"></div>
					<div class="legend_text">自來水管線<br><img src="marker_icon/line_blue.png" width="32"></div>
					<div class="legend_text">瓦斯管線<br><img src="marker_icon/line_purple.png" width="32"></div>
					<div class="legend_text">輸油管線<br><img src="marker_icon/line_black.png" width="32"></div>
				`)
				if (overlay_dataset['ncdr-earthquake']) overlay_dataset['ncdr-earthquake'].addTo(map)
				break
		}
	}

	function renderCwbFtpEarthquakeInfo(cwbNewestData){
		var cwbNewestHtml = {
				content: "",
				table: "",
				result: {},
				pie: {}
			}
		if (cwbNewestData) {
			cwbNewestHtml.content = `<h5 class="font-weight-bold mb-2"><i class="fas fa-info mr-2"></i>震度報告詳細資訊</h5>  時間：${cwbNewestData.time} <br/>`
			cwbNewestData.data.forEach(el => {
				el.intensityNumber = {
					name: el["震度"],
					value: earthquakeIntensityMapping[el["震度"]]
				}
			})
			cwbNewestData.data = cwbNewestData.data.sort(function(a,b){ return b.intensityNumber.value - a.intensityNumber.value})
			cwbNewestData.data.forEach((el, index) => {
				cwbNewestHtml.result[el["行政區"]] = el.intensityNumber
				if (el["震度"] !== "0級") {
					cwbNewestHtml.table += `
						<tr>
							<td>${(index + 1)}</td>
							<td>${el["行政區"]}</td>
							<td>${el["震度"]}</td>
						</tr>`
					if (!cwbNewestHtml.pie[el["震度"]]) {
						cwbNewestHtml.pie[el["震度"]] = {
							name: el["震度"],
							color: getEarthquakeGridColor(earthquakeIntensityMapping[el["震度"]]),
							y: 0
						}
					}
					cwbNewestHtml.pie[el["震度"]].y += 1
				}
			})
			overlay_dataset['cwb-ntpc-earthquake']  && map.removeLayer(overlay_dataset['cwb-ntpc-earthquake'])
			overlay_dataset['cwb-ntpc-earthquake'] = L.geoJSON(overlay_dataset['Basic_map'], {
				style: function(feature){
					var fillColor, fillOpacity
					if (cwbNewestHtml.result[feature.properties.TOWNNAME]) {
						fillColor = getEarthquakeGridColor(cwbNewestHtml.result[feature.properties.TOWNNAME].value)
						fillOpacity = 1
					} else {
						fillOpacity = 0
					}
					return {
						fillColor: fillColor,
						color: "grey",
						weight: 1,
						fillOpacity: fillOpacity
					}
				},
				onEachFeature: function(feature, layer){
					var tooltip = "無震度資訊"
					if (cwbNewestHtml.result[feature.properties.TOWNNAME]) {
						tooltip = `震度達${cwbNewestHtml.result[feature.properties.TOWNNAME].name}`
					}
					layer.bindTooltip(`${feature.properties.TOWNNAME}`, {
						sticky: true,
						opacity: .8,
						permanent: true, 
						direction:"center",
						className: 'leaflet-tooltip-own' 
					})
				}
			}).addTo(map)
		}

		// let earthquake_date = cwbNewestData.time.split(" ")[0].split("-").join("")
		// let earthquake_time = cwbNewestData.time.split(" ")[1].split(":").join("")
		// let earthquake_id
		// const earthquake_report_url_params = earthquake_date.slice(0,6) + "/" + earthquake_date + earthquake_time + 
		$("#topic-earthquake-info-cwb-source-detailed-content").html(`
			${cwbNewestHtml.content}
			<h6 class="mt-1"><i class="fas fa-chart-pie mr-2"></i>區域震度統計
				<i class="fas fa-info-circle ml-1 p-cursor" hover_toggle="true" title="本市各行政區震度為電腦自動計算本市 29 區即時地震站觀測值之結果，於地震初期提供查詢各行政區震度，倘有需要各行政區「修正」震度應另洽氣象署地震測報中心瞭解。"></i>
			</h6>
			<div class="w-100 h-280" id="topic-earthquake-info-cwb-source-intensity-chart"></div>
			<h6 class="mt-3"><i class="fas fa-table mr-2"></i>區域震度列表</h6>
			<table class="table table-sm table-bordered mt-2">
				<thead class="thead-dark">
					<tr>
						<th>#</th>
						<th>行政區</th>
						<th>震度</th>
					</tr>
				</thead>
				<tbody>
					${cwbNewestHtml.table}
				</tbody>
			</table>
			<h6 class="mt-3"><i class="fas fa-clipboard-list mr-2"></i>地震報告圖
				<i class="fas fa-info-circle ml-1 p-cursor" hover_toggle="true" title="地震報告於地震初期提供查詢震央及芮氏規模。"></i>
			</h6>
			<img class="w-100 mr-2" src="${cwbNewestData.report_url}">
			<h6 class="mt-3"><i class="fas fa-list mr-2"></i>地震詳細資料</h6>
			<table class="table table-sm table-bordered mt-2 small">
				<thead class="thead-dark">
					<tr>
						<th>行政區</th>
						<th>PGA(V)</th>
						<th>PGA(NS)</th>
						<th>PGA(EW)</th>
						<th>PGV(V)</th>
						<th>PGV(NS)</th>
						<th>PGV(EW)</th>
					</tr>
				</thead>
				<tbody>
					${cwbNewestData.data.map(el => `<tr>
						<td>${el["行政區"]}</td>
						<td>${el["PGA(V)"].split('=')[1].trim()}</td>
						<td>${el["PGA(NS)"].split('=')[1].trim()}</td>
						<td>${el["PGA(EW)"].split('=')[1].trim()}</td>
						<td>${el["PGV(V)"].split('=')[1].trim()}</td>
						<td>${el["PGV(NS)"].split('=')[1].trim()}</td>
						<td>${el["PGV(EW)"].split('=')[1].trim()}</td>
					</tr>`).join("")}
				</tbody>
			</table>`
		)

		pie_chart_advanced({
			renderdiv: "topic-earthquake-info-cwb-source-intensity-chart",
			title: "",
			tooltipPointFormat: "共{point.y}區</b>",
			dataLabelsFormatter: function () { 
				  return `${this.point.name}: ${(this.point.y)}區`; 
			},
			series: {
				name: "震度分布",
				data: Object.values(cwbNewestHtml.pie)
			}
		})
	}

	function renderTopicEarthquakeNewest(){
		loader_asynchronous(function(){
			var data = raw_data["近期有感地震"], pic_url = "", info_data, html_string = ""
			try {
				info_data = data.info_data,
				html_string = 
					"編號：第" + info_data.records.earthquake[0].earthquakeNo + "號<br>" +
					"發震時間：" + info_data.records.earthquake[0].earthquakeInfo.originTime.slice(0, 19) + "<br>" + 
					"事件簡述：" + info_data.records.earthquake[0].reportContent
				pic_url = info_data.records.earthquake[0].reportImageURI
			} catch (error) {}
			$('#topic-earthquake-render-div').html('<div id="topic-earthquake-newest-ncdr"></div>')
			renderNcdrEarthquakeOtherInfo(
				'topic-earthquake-newest-ncdr', 
				ncdrEarthquakeFirst.event_id, 
				{ 
					basic: ncdrEarthquakeFirst.mail_content, 
					cwbinfo: { 
						text: html_string,
						pic: `<img class="w-100 modal-img mt-2" src="${pic_url}">` 
					}
				}
			)
			if(overlay_dataset['ncdr-earthquake']){map.removeLayer(overlay_dataset['ncdr-earthquake'])}
			overlay_dataset['ncdr-earthquake'] = earthquake_alert_ncdr(ncdrEarthquakeFirst).addTo(map)	
		})
	}

	function renderTopicEarthquakeHistory(view_type){
		var simulationData = ajax_call(publicPath + '/napi/simulate/earthquakencdr?event=simulation'),
			simulationDataObject = {},
			optionListHtml = ''
		
		if (view_type == 'simulation') {
			simulationData.forEach(el => {
				simulationDataObject[el.event_id] = el
				optionListHtml += `<option value="${el.event_id}">${el.event_id}</option>`
			})
		} else {
			ncdrEarthquakeList.forEach(function(element, index){
				var thisEventName = element.event_id.slice(2,6) + "/" + element.event_id.slice(6,8) + "/" + element.event_id.slice(8,10) + " " + element.event_id.slice(11,13) + ":" + element.event_id.slice(13,15)
				if (element.mail_content.match('新北市')) {
					optionListHtml += `<option class="text-white bg-danger" value="${index}">${thisEventName}地震事件</option>`
				} else {
					optionListHtml += `<option value="${index}">${thisEventName}地震事件</option>`
				}
			})
		}
		
		$('#topic-earthquake-render-div').html(`
			<h5 class="font-weight-bold mb-2"><i class="fas fa-list-alt mr-2"></i>地震事件選單</h5> 
			<div class="input-group mb-2 pb-2 border-b-normal">
				<div class="input-group-prepend">
					<label class="input-group-text">選擇事件</label>
				</div>
				<select class="custom-select" id="topic-earthquake-history-viwer">
					${optionListHtml}
				</select>
			</div>
			<div id="topic-earthquake-history-ncdr"></div>`
		)
		$("#topic-earthquake-history-viwer option").eq(0).attr("selected", true)
		
		let initialRenderList = view_type == 'simulation' ? simulationData : ncdrEarthquakeList
		renderHistoryInfo(initialRenderList[0])

		$('#topic-earthquake-history-viwer').change(function(){
			let renderList = $(this).val().match("模擬") ? simulationDataObject : ncdrEarthquakeList
			renderHistoryInfo(renderList[$(this).val()])
		})

		function renderHistoryInfo(element){
			loader_asynchronous(function(){
				if(overlay_dataset['ncdr-earthquake']){map.removeLayer(overlay_dataset['ncdr-earthquake'])}
				$('#topic-earthquake-history-ncdr').html('<div id="topic-earthquake-history-ncdr"></div>')
				renderNcdrEarthquakeOtherInfo(
					'topic-earthquake-history-ncdr', 
					element.event_id,
					{
						basic: element.mail_content
					}
				)
				overlay_dataset['ncdr-earthquake'] = earthquake_alert_ncdr(element).addTo(map)	
				// picture and exception handle
				if ($('#topic-earthquake-history-viwer').val().match("山腳斷層")) {
					backgroud_layer_control("山腳斷層", 'close')
					setTimeout(backgroud_layer_control("山腳斷層"), 1000)
				}
			})
		}
	}

	function renderNcdrEarthquakeOtherInfo(div, eventId, html){
		let info_tab = `
			<li class="nav-item w-50 text-center">
				<a class="nav-link" data-toggle="tab" href="#topic-earthquake-info-basic" role="tab">基本資訊</a>
			</li>
			<li class="nav-item w-50 text-center">
				<a class="nav-link active" data-toggle="tab" href="#topic-earthquake-info-analysis" role="tab">關鍵區位分析</a>
			</li>
		`
		if ($('#topic-earthquake-history-viwer').val()) {
			if ($('#topic-earthquake-history-viwer').val().match("Terria")) {
				info_tab = `
					<li class="nav-item w-33 text-center">
						<a class="nav-link" data-toggle="tab" href="#topic-earthquake-info-basic" role="tab">基本資訊</a>
					</li>
					<li class="nav-item w-33 text-center">
						<a class="nav-link active" data-toggle="tab" href="#topic-earthquake-info-analysis" role="tab">關鍵區位分析</a>
					</li>
					<li class="nav-item w-33 text-center">
						<a class="nav-link" data-toggle="tab" href="#topic-earthquake-info-dmgbld" role="tab">預估損毀建物</a>
					</li>
				`
			}
		}
		$('#' + div).html(`
			<ul id="topic-earthquake-info-ul" class="nav nav-tabs mt-10p" role="tablist">
				${info_tab}
			</ul>
			<div class="tab-content">
				<div class="tab-pane fade" role="tabpanel" id="topic-earthquake-info-basic">
					<div class="card-body">
						<h5 class="font-weight-bold mb-2"><i class="fas fa-info mr-2"></i>地震資訊</h5>
						${html.basic}
						<h5 class="font-weight-bold mb-2"><i class="fas fa-table mr-2"></i>震度評估</h5>
					</div>
				</div>
				<div class="tab-pane fade" role="tabpanel" id="topic-earthquake-info-dmgbld">
					<div class="card-body"></div>
				</div>
				<div class="tab-pane fade show active" role="tabpanel" id="topic-earthquake-info-analysis">
					<div class="card-body topic-earthquake-ncdr-other-info"></div>
				</div>
			</div>`
		)
		
		// invisible
		var targetNode = ['b', 'pre', 'p', 'caption']
		targetNode.forEach(function(node){
			$('#' + div).find(node).each(function(){
				$(this).remove()
			})
		})
		$('#' + div).find('table').each(function(){
			$(this).addClass('table table-bordered table-sm w-100 text-center mt-2')
		})
		$('#' + div).find('td').each(function(){
			$(this).attr('align', '')
		})
		$('#' + div).find('table').eq(0).find('th').eq(0).remove()
		$('#' + div).find('table').eq(0).find('td').eq(0).remove()
		// picture and exception handle
		if (eventId.match("山腳斷層")) {
			$('#home_view').click()
			setTimeout(function(){
				backgroud_layer_control("山腳斷層")
			}, 2000)
		} else {
			// $('#topic-earthquake-info-basic .card-body').append('<hr><h5 class="font-weight-bold mb-2"><i class="far fa-images mr-2"></i>相關圖片</h5><img class="w-100 modal-img" src="' + publicPath + '/ncdr_earthquake/eqsms/data/' + eventId + '_P3.png"></img>')
			if (overlay_dataset["山腳斷層"]) { map.removeLayer(overlay_dataset["山腳斷層"]) }
		}
		// cwb api info
		if (div == 'topic-earthquake-newest-ncdr') {
			$('#' + div).find('table').eq(0).before(html.cwbinfo.text)
			$('#topic-earthquake-info-basic .card-body').append(html.cwbinfo.pic)
		}
		// intensity table
		var earthquakeIntensityTable = $('#' + div).find('table').eq(1).detach()
		$('#' + div + " #topic-earthquake-info-basic .card-body").append(earthquakeIntensityTable)

		// dmgbld chart & table
		$('#' + div + " #topic-earthquake-info-dmgbld .card-body").html(`
			<h5 class="font-weight-bold mb-2"><i class="fas fa-table mr-2"></i>預估損毀建物</h5>
			<p class="mb-1"><i class="fas fa-circle mr-2"></i>各行政區統計</p>
			<div class="w-100 h-300" id="topic-earthquake-ncdr-dmgbld-chart"></div>
			<p class="mb-1"><i class="fas fa-circle mr-2"></i>各里詳細統計</p>
			<div id="dmgbld-stat"></div>
		`)

		let data = $('#topic-earthquake-history-viwer').val() == '2023年Terria模擬5強震度事件'
			? ajax_call("geojson/earthquake/teria5強建物.geojson")
			: ajax_call("geojson/earthquake/teria6弱建物.geojson")
		
		const resultObj = {};
		data.features.forEach(el => {
			const key = `${el.properties.TownName}-${el.properties.VillName}`;
			if (!resultObj[key]) {
				resultObj[key] = { TownName: el.properties.TownName, VillName: el.properties.VillName, sum: 0, geo: []};
			}
			resultObj[key].geo.push({
				info: {
					TownName: el.properties.TownName,
					VillName: el.properties.VillName,
					dmgbld: el.properties.DmgBldMdr
				}, 
				geo: el.geometry.coordinates
			})
			resultObj[key].sum += el.properties.DmgBldMdr
		});
		const resultArr = Object.values(resultObj)
		
		let exportArray = [], tr_tds = ''
		resultArr.forEach(el => {
			exportArray.push([el.TownName, el.VillName, el.sum.toFixed(2)])
			tr_tds += `
				<tr class="p-cursor dmgbld-target" geo=${JSON.stringify(el.geo)}>
					<td>${el.TownName}</td>
					<td>${el.VillName}</td>
					<td>${el.sum.toFixed(2)}</td>
				</tr>`
		})
		$("#dmgbld-stat").html(`
			<table id="dmgbld-stat-table" class="text-center mt-2 table table-sm table-bordered">
				<thead class="thead-dark"><tr><th>行政區</th><th>里名</th><th>預估損毀建物(棟)</th></tr></thead>
				<tbody>${tr_tds}</tbody>
			</table>
			<button type="button" class="btn btn-success btn-sm btn-block mt-2" id="dmgbld-stat-table-download">表單下載</button>	
		`)
		$("#dmgbld-stat-table").DataTable({"order": [[ 2, "desc" ]],})
		$("#dmgbld-stat-table-download").click(function(){
			downloadxlsx("Terria模擬地震預估損毀建物.xlsx", ['預估損毀建物(棟)'], [exportArray]);
		})

		const resultObj_dist = {};
		data.features.forEach(el => {
			const key = `${el.properties.TownName}`;
			if (!resultObj_dist[key]) {
				resultObj_dist[key] = { TownName: el.properties.TownName, sum_by_dist: 0 };
			}
			resultObj_dist[key].sum_by_dist += el.properties.DmgBldMdr
		});
		const resultArr_dist = Object.values(resultObj_dist)
		let dataset = resultArr_dist.map(el => [el.TownName, Math.floor(el.sum_by_dist)])

		Highcharts.chart("topic-earthquake-ncdr-dmgbld-chart", {
			chart: {type: 'column'},
			title: '',
			xAxis: {
				categories: dataset.map(el => el[0]),
				labels: {
					step: 1,
					style: {
						fontWeight: 'bold',
						color: 'rgba(0, 0, 0, 1)',
						fontSize: '12px'
					},
					useHTML: true,
					formatter: function(){
						var string = "";
						for(var i = 0; i < this.value.length; i++){
							string += this.value.slice(i, (i+1)) + "<br>";
						}
						return string;
					}
				}
			},
			yAxis: {
				allowDecimals: false,
				min: 0,
				title: {text: ''},
				labels: {
					useHTML: true,
					formatter: function(){
						return this.value + '棟'
					}
				},
				stackLabels: {
					enabled: true,
					style: {
						fontWeight: 'bold',
						color: 'rgba(0, 0, 0, 1)'
					}
				}
			},
			tooltip: {
				pointFormat: '<span>{series.name}</span>: <b>{point.y}棟</b> ({point.percentage:.0f}%)<br/>',
				shared: true
			},
			exporting: {
				enabled: true
			},
			plotOptions: {
				column: {
					stacking: "normal",
					cursor: 'default',
				},
				series: {
					cursor: 'pointer',
					point: {
						events: {
							click: function () {
								if (overlay_dataset["temp_map"] != undefined){map.removeLayer(overlay_dataset["temp_map"])}
								let query_condition = this.category;
								let target_dist = resultArr.find(el => el.TownName.includes(this.category))['geo'][0]
								map.setView(target_dist['geo'][0][0][0].slice().reverse(), 12)
								$("#dmgbld-stat-table_filter input").val(query_condition).keyup()
							}
						}
					}
				}
			},
			legend: {
				enabled: false
			},
			series: [{
				name: '預估損毀建物',
				// colors: [
				// 	'#9b20d9', '#9215ac', '#861ec9', '#7a17e6', '#7010f9', '#691af3',
				// 	'#6225ed', '#5b30e7', '#533be1', '#4c46db', '#4551d5', '#3e5ccf',
				// 	'#3667c9', '#2f72c3', '#277dbd', '#1f88b7', '#1693b1', '#0a9eaa',
				// 	'#03c69b',  '#00f194'
				// ],
				// colorByPoint: true,
				// groupPadding: 0,
				data: dataset,
				// dataLabels: {
				// 	enabled: true,
				// 	rotation: -90,
				// 	color: '#FFFFFF',
				// 	align: 'right',
				// 	format: '{point.y:.1f}', // one decimal
				// 	y: 10, // 10 pixels down from the top
				// 	style: {
				// 		fontSize: '13px',
				// 		fontFamily: 'Verdana, sans-serif'
				// 	}
				// }
			}]
		});

		// other info
		$('#' + div + " .topic-earthquake-ncdr-other-info").html(`
			<h5 class="font-weight-bold mb-2"><i class="fas fa-book-open mr-2"></i>關鍵區位分析
				<i class="fas fa-info-circle ml-1 p-cursor" hover_toggle="true" title="高風險關鍵區位即時分析係提供地震發生初期，根據NCDR 提供之推估該次地震網格化等震度資訊，透過系統自動化分析，列舉高風險區位巡檢建議名單，提供本府進行重點式的訪查巡視。(水利局及工務局於推估震度 4 級範圍內之關鍵基礎設施全數巡檢。)"></i>
			</h5>
			<div class="input-group mb-2 pb-2 border-b-normal">
				<div class="input-group-prepend">
					<label class="input-group-text">震度級數篩選</label>
				</div>
				<select class="custom-select" id="topic-earthquake-ncdr-earthquake-level-filter">
					<option value="7">震度達7級以上對象</option>
					<option value="6">震度達6級以上對象</option>
					<option value="5">震度達5級以上對象</option>
					<option value="4" selected>震度達4級以上對象(預設)</option>
					<option value="3">震度達3級以上對象</option>
					<option value="2">震度達2級以上對象</option>
				</select>
			</div>
			<ul class="nav nav-tabs mb-2 mt-10p" role="tablist">
				<li class="nav-item w-33 text-center">
					<a class="nav-link active" data-toggle="tab" href="#topic-earthquake-ncdr-survey" role="tab">重大優先巡檢</a>
				</li>
				<li class="nav-item w-33 text-center">
					<a class="nav-link" data-toggle="tab" href="#topic-earthquake-ncdr-infrastruction" role="tab">一般關注設施</a>
				</li>
				<li class="nav-item w-33 text-center">
					<a class="nav-link" data-toggle="tab" href="#topic-earthquake-ncdr-pipeline" role="tab">管線衝擊評估</a>
				</li>
			</ul>
			<div class="tab-content">
				<div class="tab-pane fade show active" role="tabpanel" id="topic-earthquake-ncdr-survey"></div>
				<div class="tab-pane fade" role="tabpanel" id="topic-earthquake-ncdr-infrastruction"></div>
				<div class="tab-pane fade" role="tabpanel" id="topic-earthquake-ncdr-pipeline"></div>
			</div>`
		)

		doAllNcdrEarthquakeDetailInfo($('#topic-earthquake-ncdr-earthquake-level-filter').val())

		$('#topic-earthquake-ncdr-earthquake-level-filter').change(function(){
			doAllNcdrEarthquakeDetailInfo($(this).val())
		})

		function doAllNcdrEarthquakeDetailInfo(level){
			$("#topic-earthquake-ncdr-survey").html('<div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div>')
			$("#topic-earthquake-ncdr-infrastruction").html('<div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div>')
			ajax_call_async(publicPath + "/napi/simulate/earthquakencdrinfo?data=report&type=survey&event=" + eventId + "&level=" + level, function(data){
				renderrNcdrEarthquakeDetailInfo(data, {
					staPrototype: function(){
						return {"bridge": 0, "road": 0, "pump": 0, "othergate": 0, "sum": 0}
					},
					type: { 
						bridge: { name: "重要橋梁", authority: "工務局", theadString: '<th>行政區</th><th>名稱</th><th class="d-none">長度<br>(m)</th><th>震度</th>', thead: ["行政區", "名稱", "震度"], layer: "edp3:ntc_bridge_new", style: "bridge"}, 
						road: { name: "重要道路", authority: "工務局", theadString: '<th>行政區</th><th>名稱</th><th>長度<br>(m)</th><th>震度</th>', thead: ["行政區", "名稱", "長度(m)", "震度"], layer: "edp3:ntc_road_public3", style: "line_black"}, 
						othergate: { name: "橫移門", authority: "水利局", theadString: '<th>行政區</th><th>名稱</th><th>地址</th><th>震度</th>', thead: ["行政區", "名稱", "地址", "震度"], layer: "edp3:ntc_othergate1", style: "othergate" }, 
						pump: { name: "抽水站", authority: "水利局", theadString: '<th>行政區</th><th>名稱</th><th>地址</th><th>震度</th>', thead: ["行政區", "名稱", "地址", "震度"], layer: "edp3:ntc_pump", style: "pump" }
					},
					elementKey: ['region', 'name', 'length', 'intensity'],
					render: 'topic-earthquake-ncdr-survey',
					name: "巡檢設施",
					earthquake: eventId,
					level: level,
					layerquery: 'survey',
					downloadTable: {
						name: "重大優先巡檢"
					},
					chart: {
						unit: "處",
						pie: {
							subtitle: "件數",
						}
					}
				})
			})
			ajax_call_async(publicPath + "/napi/simulate/earthquakencdrinfo?data=report&type=infrastrction&event=" + eventId + "&level=" + level, function(data){
				renderrNcdrEarthquakeDetailInfo(data, {
					staPrototype: function(){
						return {"school": 0, "hospital": 0, "care_normal": 0, "care_pregnant": 0, "ambulance": 0, "drug_store": 0, "sum": 0}
					},
					type: { 
						school: { name: "學校單位", authority: "教育局", thead: ["行政區", "名稱", "潛勢等級", "震度"], theadString: '<th>行政區</th><th>名稱</th><th>潛勢等級</th><th>震度</th>', layer: "edp3:ntc_school_earthquake", style: "school" }, 
						hospital: { name: "醫院機構", authority: "衛生局", thead: ["行政區", "名稱", "地址", "震度"], theadString: '<th>行政區</th><th>名稱</th><th>地址</th><th>震度</th>', layer: "edp3:ntc_hospital", style: "hospital" }, 
						care_normal: { name: "一般護理之家", authority: "衛生局", thead: ["行政區", "名稱", "地址", "震度"], theadString: '<th>行政區</th><th>名稱</th><th>地址</th><th>震度</th>', layer: "edp3:ntc_care_normal", style: "hospital" }, 
						care_pregnant: { name: "產後護理之家", authority: "衛生局", thead: ["行政區", "名稱", "地址", "震度"], theadString: '<th>行政區</th><th>名稱</th><th>地址</th><th>震度</th>', layer: "edp3:ntc_care_pregnant", style: "hospital" }, 
						ambulance: { name: "救護車營業機構", authority: "衛生局", thead: ["行政區", "名稱", "地址", "震度"], theadString: '<th>行政區</th><th>名稱</th><th>地址</th><th>震度</th>', layer: "edp3:ntc_ambulance", style: "hospital" }, 
						drug_store: { name: "健保署特約藥局", authority: "衛生局", thead: ["行政區", "名稱", "地址", "震度"], theadString: '<th>行政區</th><th>名稱</th><th>地址</th><th>震度</th>', layer: "edp3:ntc_drug_store", style: "hospital" }
					},
					elementKey: ['region', 'name', 'type', 'intensity'],
					render: 'topic-earthquake-ncdr-infrastruction',
					name: "關鍵設施",
					earthquake: eventId,
					level: level,
					layerquery: 'infrastrction',
					downloadTable: {
						name: "一般關注設施"
					},
					chart: {
						unit: "處",
						pie: {
							subtitle: "件數",
						}
					}
				})
			})
			ajax_call_async(publicPath + "/napi/simulate/earthquakencdrpipeinfo?event=" + eventId + "&level=" + level, function(data){
				renderrNcdrEarthquakeDetailInfo(data, {
					staPrototype: function(){
						return {"electricity": 0, "water": 0, "gas": 0, "oil": 0, "sum": 0}
					},
					type: { 
						electricity: { name: "電力管線", authority: "電力管線", thead: ["行政區", "震度", "影響長度"], theadString: '<th>行政區</th><th>震度</th><th>影響長度</th>', layer: "edp3:pipeline_electricity", style: "line_yellow" }, 
						water: { name: "自來水管線", authority: "自來水管線", thead: ["行政區", "名稱", "潛勢等級", "震度"], theadString: '<th>行政區</th><th>震度</th><th>影響長度</th>', layer: "edp3:pipeline_water", style: "line" }, 
						gas: { name: "瓦斯管線", authority: "瓦斯管線", thead: ["行政區", "名稱", "潛勢等級", "震度"], theadString: '<th>行政區</th><th>震度</th><th>影響長度</th>', layer: "edp3:pipeline_gas", style: "line_purple" }, 
						oil: { name: "輸油管線", authority: "輸油管線", thead: ["行政區", "名稱", "潛勢等級", "震度"], theadString: '<th>行政區</th><th>震度</th><th>影響長度</th>', layer: "edp3:pipeline_oil", style: "line_black" } 
					},
					elementKey: ['region', 'name', 'type', 'intensity'],
					render: 'topic-earthquake-ncdr-pipeline',
					name: "管線設施",
					earthquake: eventId,
					level: level,
					layerquery: 'pipeline',
					downloadTable: {
						name: "管線衝擊評估"
					},
					chart: {
						unit: "公尺",
						pie: {
							subtitle: "影響長度",
						}
					}
				})
			})
		}
	}

	$('#topic-earthquake-render-div').on('click', '.dmgbld-target', function(){
		if (overlay_dataset["temp_map"] != undefined){map.removeLayer(overlay_dataset["temp_map"])}
		let selected_vill = JSON.parse($(this).attr('geo'))
		map.setView(selected_vill[0]['geo'][0][0][0].slice().reverse(), 13) // using slice() to avoid mutating original array
		
		let features = selected_vill.map(el => {
			return L.polygon(
				el.geo[0][0].map(coord => coord.reverse()),
				{
					color: '#ffff00',
					weight: 3,
					fill: false
				}
			).bindTooltip(
				`<div>
					<h6>行政區：${el.info.TownName}</h6>
					<h6>村里：${el.info.VillName}</h6>
					<h6>預估建物損毀中位數：${el.info.dmgbld} 棟</h6>
				</div>`
			);
		});
		overlay_dataset["temp_map"] = L.layerGroup(features).addTo(map);
	})

	function renderrNcdrEarthquakeDetailInfo(data, option){
		var sta_data = {},
			authority_data = {},
			html = { layerOption: "" },
			initialData = data,
			pipeKeyMapping = {
				"pubpipe_electricity": { key: "electricity", name: "電力" }, 
				"pubpipe_water": { key: "water", name: "自來水" },
				"pubpipe_gas": { key: "gas", name: "瓦斯" },
				"pubpipe_oil": { key: "oil", name: "輸油" }
			}
		if (option.render != "topic-earthquake-ncdr-pipeline") {
			Object.keys(data).forEach(function(key){
				data[key].forEach(function(element){
					if (!sta_data[element.region]){
						sta_data[element.region] = new option.staPrototype
					}
					sta_data[element.region].sum += element.count
					sta_data[element.region][key] += element.count
				})
			})
			Object.keys(sta_data).forEach(function(region){
				Object.keys(sta_data[region]).forEach(function(key){
					if (key != 'sum') {
						if (!authority_data[option.type[key].authority]) { authority_data[option.type[key].authority] = 0 }
						authority_data[option.type[key].authority] += sta_data[region][key]
					}
				})
			})
		} else {
			data.forEach(function(element){
				element.length = parseInt(element.length)
				if (!sta_data[element.region]){
					sta_data[element.region] = new option.staPrototype
				}
				sta_data[element.region].sum += element.length
				sta_data[element.region][pipeKeyMapping[element.pipetype].key] += element.length
			})
			Object.keys(sta_data).forEach(function(region){
				Object.keys(sta_data[region]).forEach(function(key){
					if (key != 'sum') {
						if (!authority_data[option.type[key].authority]) { authority_data[option.type[key].authority] = 0 }
						authority_data[option.type[key].authority] += sta_data[region][key]
					}
				})
			})
		}
		Object.keys(option.type).forEach(function(each){
			html.layerOption += `<option value="${each},${option.type[each].layer}">${option.type[each].name}</option>`
		})
		$('#' + option.render).html(`
			<p class="mb-1"><i class="fas fa-circle mr-2"></i>權責單位統計</p>
			<div class="w-100 h-300" id="${option.render}-authority-chart"></div>
			<p class="mb-1"><i class="fas fa-circle mr-2"></i>設施類型統計</p>
			<div class="w-100 h-300" id="${option.render}-chart"></div>
			<p class="mb-1"><i class="fas fa-circle mr-2"></i>巡檢清單與位置</p>
			<div class="input-group mb-2">
				<div class="input-group-prepend">
					<label class="input-group-text">圖層對象選擇</label>
				</div>
				<select class="custom-select" id="${option.render}-layer-option">
					${html.layerOption}
				</select>
			</div>
			<div id="${option.render}-table"></div>`
		)
		// chart
		console.log(sta_data, authority_data)
		pie_chart(
			authority_data, { 
				renderDiv: option.render + "-authority-chart",
				unit: option.chart.unit,
				subtitle: option.chart.pie.subtitle
			}
		)
		stacked_chart_for_earthquake_topic({
			div: option.render + "-chart",
			data: [sta_data],
			key_name: Object.keys(option.type),
			label: Object.values(option.type).map(function(element){return element.name}),
			color: Object.values(option.type).map(function(element){return element.color}),
			stackingType: "normal",
			yAxisLabel: option.chart.unit,
			click_event_binding: function(trigger_input){
				var query_condition = trigger_input, thisLayer
				overlay_dataset['Basic_map'].features.forEach(function(feature){
					if (feature.properties.TOWNNAME == query_condition) { thisLayer = feature }
				})
				if (overlay_dataset["temp_map"]) { map.removeLayer(overlay_dataset["temp_map"]) }
				overlay_dataset["temp_map"] = L.geoJson(thisLayer,{
					color: "#ef5285",
					weight: 3,
					fill: false,
					interactive: false
				}).addTo(map);
				map.fitBounds(overlay_dataset["temp_map"].getBounds())
				$("#" + option.render + "-table_filter input").val(query_condition).keyup()
			},
			redrawNoTrigger: true
		})

		// layer & table
		$('#' + option.render + '-layer-option').change(function(){
			if (overlay_dataset["temp_map"] != undefined){map.removeLayer(overlay_dataset["temp_map"])}
			var target = $(this).val().split(",")[0], html = "", exportArray = [option.type[target].thead], thisSelectName = ""
			if (option.render != "topic-earthquake-ncdr-pipeline") {
				$("#" + option.render + "-table").html('<div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div>')
			}
			ajax_call_async(publicPath + '/napi/simulate/earthquakencdrinfo?type=' + option.layerquery + '&event=' + option.earthquake + '&level=' + option.level + '&data=row&rowtype=' + target, function(data){
				if (option.render != "topic-earthquake-ncdr-pipeline") {
					data[target].forEach(function(each){
						if (target == 'bridge') {
							exportArray.push([each.region, each[option.elementKey[1]], each.intensity])
							html += `
								<tr class="p-cursor evaluation-target" geo=${each.geo}>
									<td>${each.region}</td>
									<td>${each[option.elementKey[1]]}</td>
									<td class="d-none">${each[option.elementKey[2]]}</td>
									<td>${condition_eq_intensity(each.intensity)}</td>
								</tr>`
						} else {
							exportArray.push([each.region, each[option.elementKey[1]], each[option.elementKey[2]], each.intensity])
							html += `
								<tr class="p-cursor evaluation-target" geo=${each.geo}>
									<td>${each.region}</td>
									<td>${each[option.elementKey[1]]}</td>
									<td>${each[option.elementKey[2]]}</td>
									<td>${condition_eq_intensity(each.intensity)}</td>
								</tr>`
						}
					})
					$("#" + option.render +"-table").html(`
						<table id="${option.render}-table" class="text-center mt-2 table table-sm table-bordered">
							<thead class="thead-dark"><tr>${option.type[target].theadString}</tr></thead>
							<tbody>${html}</tbody>
						</table>
						<button type="button" class="btn btn-success btn-sm btn-block mt-2" id="${option.render}-table-download">表單下載</button>`
					)
					$("#" + option.render +"-table table").DataTable({"order": [[ 3, "desc" ]],})
					$("#" + option.render + "-table-download").click(function(){
						downloadxlsx(option.downloadTable.name + "表_" + option.earthquake + "事件.xlsx", [option.downloadTable.name], [exportArray]);
					})
				} else {
					initialData.forEach(function(element){
						if (pipeKeyMapping[element.pipetype].key == target) {
							thisSelectName = pipeKeyMapping[element.pipetype].name
							exportArray.push([element.region, condition_eq_intensity(element.intensity), element.length.toFixed(0) + "m"])
							html += `
								<tr>
									<td>${element.region}</td>
									<td>${condition_eq_intensity(element.intensity)}</td>
									<td>${element.length.toFixed(0)}m</td>
								</tr>`
						}
					})
					$("#" + option.render + "-table").html(`
						<table id="${option.render}-table" class="text-center mt-2 table table-sm table-bordered">
							<thead class="thead-dark"><tr>${option.type[target].theadString}</tr></thead>
							<tbody>${html}</tbody>
						</table>
						<button type="button" class="btn btn-success btn-sm btn-block mt-2" id="${option.render}-table-download">表單下載</button>`
					)
					$("#" + option.render +"-table table").DataTable({"order": [[ 2, "desc" ]],})
					$("#" + option.render + "-table-download").click(function(){
						downloadxlsx(option.downloadTable.name + thisSelectName + "表_" + option.earthquake + "事件.xlsx", [option.downloadTable.name], [exportArray]);
					})
				}
				// layer create

				// if (overlay_dataset["ncdr-earthquake-intersect-target"]) { map.removeLayer(overlay_dataset["ncdr-earthquake-intersect-target"]) }
				// var showLayer = option.type[target].layer
				// if (target == 'road') {
				// 	showLayer = 'edp3:ntc_road_new'
				// }
				// overlay_dataset["ncdr-earthquake-intersect-target"] = L.tileLayer.wms(publicPath + '/cloud/geoserver/edp3/wms?',{
				// 	layers: showLayer,
				// 	styles: option.type[target].style,
				// 	transparent: true,
				// 	format: 'image/png',
				// 	maxZoom: 22,
				// 	pane: "high-zindex-wms-layer"
				// })

				$("#map_clear").click();
				map.addLayer(overlay_dataset['ncdr-earthquake'])
				switch(target){
					case 'bridge':
						backgroud_layer_control("重要橋樑");
						break;
					case 'road':
						backgroud_layer_control("重要道路");
						break;
					case 'othergate':
						backgroud_layer_control("橫移門");
						break;
					case 'pump':
						backgroud_layer_control("抽水站");
						break;
					case 'school':
						backgroud_layer_control("學校單位");
						break;
					case 'hospital':
						backgroud_layer_control("醫院機構");
						break;
					case 'care_normal':
						backgroud_layer_control("一般護理之家");
						break;
					case 'care_pregnant':
						backgroud_layer_control("產後護理之家");
						break;
					case 'ambulance':
						backgroud_layer_control("救護車營業機構");
						break;
					case 'drug_store':
						backgroud_layer_control("健保署特約藥局");
						break;
					case 'electricity':
						backgroud_layer_control("電力管線");
						break;
					case 'water':
						backgroud_layer_control("自來水管線");
						break;
					case 'gas':
						backgroud_layer_control("瓦斯管線");
						break;
					case 'oil':
						backgroud_layer_control("輸油管線");
						break;
				}
				backgroud_layer_control("山腳斷層")

				var nowActiveInfo = $("#topic-earthquake-info-ul").find(".active").eq(0).attr("href")
				if (nowActiveInfo == '#topic-earthquake-info-analysis') {
					map.addLayer(overlay_dataset["ncdr-earthquake-intersect-target"])
					map.off("click", ncdr_earthquake_intersect_detail_info)
					map.on("click", ncdr_earthquake_intersect_detail_info)
				}
			})
		})
		$($(".topic-earthquake-ncdr-other-info").find('.active').eq(0).attr('href') + '-layer-option').trigger('change')
	}

	$('#topic-earthquake-render-div').on('click', '.evaluation-target', function(){
		var thisGeo = JSON.parse($(this).attr('geo')), thisLayer = L.geoJSON(thisGeo), supportLbsPoint
		if (overlay_dataset["temp_map"] != undefined){map.removeLayer(overlay_dataset["temp_map"])}
		if (thisGeo.type.match('MultiPoint')) {
			supportLbsPoint = [thisGeo.coordinates[0][1], thisGeo.coordinates[0][0]]
			map.setView([thisGeo.coordinates[0][1], thisGeo.coordinates[0][0]], 16)
			overlay_dataset["temp_map"] = L.marker(supportLbsPoint).addTo(map)
		} else {
			var buffered = L.geoJSON(turf.buffer(thisGeo, 50, {units: 'meters'}));
			map.fitBounds(buffered.getBounds())
			overlay_dataset["temp_map"] = buffered.addTo(map)
		}
	})

	$('#topic-earthquake-render-div').on('click', '#topic-earthquake-info-ul .nav-link', function(){
		var target = $(this).attr('href')
		map.removeLayer(overlay_dataset["ncdr-earthquake-intersect-target"])
		map.off("click", ncdr_earthquake_intersect_detail_info)
		if (target == '#topic-earthquake-info-analysis') {
			overlay_dataset["ncdr-earthquake-intersect-target"].addTo(map)
			map.on("click", ncdr_earthquake_intersect_detail_info)
		}
	})

	$('#topic-earthquake-render-div').on('click', '#topic-earthquake-info-analysis .nav-link', function(){
		$($(this).attr('href') + '-layer-option').trigger('change')
	})

	var targetKeyDict = {
		bridge: { field: {'thb15':'隸屬鄉鎮','thb16':'隸屬村里','br01':'橋名','br11':'河流名稱','br16':'橋梁長度','br17':'橋梁寬度','br21':'建造年月','br23':'現況'}, name: "橋樑" },
		road: { field: {'thb01':'名稱', 'townname':'隸屬鄉鎮'}, name: "道路" },
		othergate: { field: {'name':'名稱','address':'地址','townname':'所屬行政區'}, name: "橫移門" },
		pump: { field: {'name_c':'名稱','addr_c':'地址','pump_tel':'連絡電話'}, name: "抽水機" },
		school: { field: {'name':'學校名稱','address':'地址','region':'所屬行政區','potential':'地震風險等級','descriptio':'地震補充說明'}, name: "學校" },
		hospital: { field: {'name':'機構名稱','no':'機構代碼','district':'行政區','address':'地址','telephone':'電話'}, name: "醫院" },
		care_normal: { field: {'title':'機構名稱','address':'地址','name':'負責人','tel':'電話','bed':'開放床數','number':'機構應配置護理人員數'}, name: "一般照護中心" },
		care_pregnant: { field: {'title':'機構名稱','address':'地址','name':'負責人','tel':'電話','bed_for_pregnant':'產後護理床開放數','bed_for_babies':'嬰兒床開放數','number':'機構應配置護理人員數'}, name: "產後照護中心" },
		ambulance: { field: {'no':'機構代碼','name':'機構名稱','telephone':'電話','address':'地址'}, name: "救護車營業機構" },
		drug_store: { field: {'tel':'電話','name':'藥局名稱','address':'地址','region':'所屬行政區'}, name: "健保署特約藥局" },
		electricity: { field: {'pipelength':'長度','pipewidth':'寬度','pmaterial':'材質','builddate':'建造時間'}, name: "電力管線" },
		water: { field: {'pipelength':'長度','pipewidth':'寬度','pmaterial':'材質','builddate':'建造時間'}, name: "自來水管線" },
		gas: { field: {'pipelength':'長度','pipewidth':'寬度','pmaterial':'材質','builddate':'建造時間'}, name: "瓦斯管線" },
		oil: { field: {'pipelength':'長度','pipewidth':'寬度','pmaterial':'材質','builddate':'建造時間'}, name: "輸油管線" }
	}
	function ncdr_earthquake_intersect_detail_info(e){
		var target = $("#topic-earthquake-info-analysis").find(".active").attr("href"),
			inputList = $(target + "-layer-option").val().split(",")
		wmsInfoDialog(e, { 
			front: publicPath + "/cloud/geoserver/edp3/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=" + inputList[1] + "&cql_filter=INTERSECTS(geom,%20POLYGON((", 
			back: ")))&outputFormat=application%2Fjson",
			keyMeta: targetKeyDict[inputList[0]].field,
			layerName: targetKeyDict[inputList[0]].name
		})
	}
}


// 一鍵通模組
function subtopic_1click () {
	// --- 來源資料拉取 ---
	// 路線選項資料來源
	// const routes_data = ajax_call(publicPath + '/napi/click1map/list');
	const routes_data = ajax_call(publicPath + '/napi/click1map/list');
	// 道路封閉資料來源(ncdr)
	// const road_break_ncdr = ajax_call(publicPath + '/napi/obs/ncdr_cap_thb_road_break')
	// 道路封閉資料來源(thb)
	const road_break_thb_raw = ajax_call(publicPath + '/napi/obs/thb_road_break')
	const road_break_thb = Array.isArray(road_break_thb_raw) ? road_break_thb_raw : []
	// 道路封閉資料來源(emic)
	var showEMIC = true
	var emic_projects = ajax_call(publicPath + '/napi/emic/emic_projects')
	var emic_projects_ntc = []
	if (emic_projects?.EEMResp.OpenCaseInfoList.openCaseInfo.length > 0) {
		emic_projects_ntc = emic_projects?.EEMResp.OpenCaseInfoList.openCaseInfo[0]?.openCaseStatusInfo
			.filter(el => el.eocName.includes('新北市'))
	}
	// 時間格式處理&比對(若案件關閉時間不存在(未關閉) or 大於目前時間 => 顯示emic道路中斷點位)
	if (emic_projects_ntc.length > 0) {
		emic_projects_ntc.forEach(el => {
			if (!el.prjEtime) return
			let dt_raw = el.prjEtime.split(' ')
			if (dt_raw[1] == '下午') {
				dt_raw[2] = String(Number(dt_raw[2].slice(0,2)) + 12) + dt_raw[2].slice(2)
			}
			let x = dt_raw[0].split('/')
			x[1] = x[1].length == 1 ? '0' + x[1] : x[1]
			x[2] = x[2].length == 1 ? '0' + x[2] : x[2]
			dt_raw[0] = x.join('-')

			let dt = new Date(dt_raw[0] + 'T' + dt_raw[2])
			if (dt.valueOf() < Date.now()) {
				showEMIC = false
			}
		})
	} else {
		showEMIC = false
	}

	let road_break_emic_raw = showEMIC ? ajax_call(publicPath + '/napi/obs/emic_road_break') : []
	const road_break_emic = road_break_emic_raw.detail
		? road_break_emic_raw.detail.filter(el => el.open_datetime == '')
		: []
	
	// 道路封閉資料來源(emis)
	const road_break_emis = raw_data['event'] // 確認是否已選擇專案(避免未選專案時報錯)
		? raw_data['event'][0].features       // 已選擇專案 > 資料整理
			.concat(raw_data['event'][1]?.features)
			.filter(el => el.properties.TrafficImpact > 0 && el.properties.STATUS != '05')
		: []                                  // 未選擇專案 > 回傳空陣列
	

	// 道路封閉 table & layer
	// table
	console.log(road_break_thb)
	const road_break_thb_table = road_break_thb.map((el, index) => 
	`<tr class="road_break_thb_row">
		<td>${index + 1}</td>
		<td>${el.info.table.tr[5].td[1].slice(0, 6)}</td>
		<td>${el.info.table.tr[5].td[1].slice(6)}</td>
		<td>${el.info.table.tr[2].td[1]}</td>
		<td>${el.info.table.tr[3].td[1]}</td>
	</tr>`)
	// <td class="d-none" id="ncdr_row_latlng">${[Number(el.area.circle.slice(0,8)), Number(el.area.circle.slice(9,18))]}</td>
	const road_break_emic_table = road_break_emic.map((el, index) =>
	`<tr class="road_break_emic_row">
		<td>${index + 1}</td>
		<td>${el.close_datetime.slice(0,19).replace('-','/').replace('T',' ') || '-'}</td>
		<td>${el.addname}</td>
		<td>${el.linecode || '-'}</td>
		<td class="d-none" id="emic_row_latlng">${[el.wgs84_x, el.wgs84_y]}</td>
	</tr>`) 
	const road_break_emis_table = road_break_emis.map((el, index) =>
	`<tr class="road_break_emis_row">
		<td>${index + 1}</td>
		<td>${timeConverter(el.properties.RPT_TIME)}</td>
		<td>${condition_status_type(el.properties.STATUS)}</td>
		<td>${el.properties.DISA_LOCATION}</td>
		<td class="d-none" id="emis_row_latlng">${el.geometry.coordinates}</td>
	</tr>`) 
	if (road_break_thb.length == 0) {
		$('#road-break-thb-table').html('<p>目前無道路封閉</p>')
	} else { $('#road-break-thb-table').html(road_break_thb_table) }
	
	if (road_break_emic.length == 0) {
		// $('#road-break-emic-table').html('<p>目前無道路封閉</p>')
		$('#road-break-emic-table').html('<p>目前EMIC未開立</p>') // 臨時調整(之後刪除改上面)
	} else { $('#road-break-emic-table').html(road_break_emic_table) }
	
	if (!raw_data['event']) { 
		$('#road-break-emis-table').html('<p>請先選擇災情專案</p>') 
	} else if (raw_data['event'] && road_break_emis.length == 0) {
		$('#road-break-emis-table').html('<p>本專案未發生影響道路交通之事件</p>')
	} else { $('#road-break-emis-table').html(road_break_emis_table) }

	// layer
	const road_break_thb_geojson = road_break_thb.map(el => {
		return {
		    "type": "Feature",
		    "geometry": {
				"type": "LineString",
				"coordinates": el.coordinates.split(' ').map(coord => coord.split(',').map(Number))
			},
		    "properties": el
		}
	}).filter(el => !el.geometry.coordinates.includes(NaN))
	// // Iterate through each point and add a buffer
	road_break_thb_geojson.forEach((el) => {
		let buffered = turf.buffer(el, 50, {units:'meters'});
		el.properties.buffered = buffered;
	});
	overlay_dataset['公路局道路封閉'] = L.geoJSON(road_break_thb_geojson, {
		style: (feature) => {
			return {
                "color": "#ff0000",  // Set line color
                "weight": 5,         // Set line weight
                // "opacity": 0.65      // Set line opacity
            };
		},
		onEachFeature: (feature, layer) => {
			layer.bindPopup(`
				<div style="width: 320px;">
					<h5 style="font-weight: 700">${feature.properties.info.table.tr[5].td[1].slice(0, 6)}</h5>
					<h6>封閉路線：${feature.properties.info.table.tr[5].td[1].slice(6)}</h6>
					<h6>封閉原因：${feature.properties.info.table.tr[8].td[1]}</h6>
					<h6>管制作為：${feature.properties.info.table.tr[9].td[1]}</h6>
					<h6>封閉開始時間：${feature.properties.info.table.tr[2].td[1]}</h6>
					<h6>預計結束時間：${feature.properties.info.table.tr[3].td[1]}</h6>
				</div>
			`)
		}
	})
	const road_break_emic_geojson = road_break_emic.map(el => {
		return {
		    "type": "Feature",
		    "geometry": {
				"type": "Point",
				"coordinates": [Number(el.wgs84_x), Number(el.wgs84_y)]
			},
		    "properties": el
		}
	}).filter(el => !el.geometry.coordinates.includes(NaN))
	// Iterate through each point and add a buffer
	road_break_emic_geojson.forEach((el) => {
		let buffered = turf.buffer(el, 50, {units:'meters'});
		el.properties.buffered = buffered;
	});
	overlay_dataset['EMIC道路封閉'] = L.geoJSON(road_break_emic_geojson, {
		pointToLayer: (feature, latlng) => {
			const icon = L.icon({
				iconUrl: "marker_icon/road_break_emic.png",
				iconSize: [30, 30],
				iconAnchor: [0, 0], 
				popupAnchor: [10, 10],
			})
			return L.marker(latlng, { icon })
		},
		onEachFeature: (feature, layer) => {
			layer.bindPopup(`
				<div style="width: 320px;">
					<h5 style="font-weight: 700">${feature.properties.linecode || '-'}</h5>
					<h6>封閉時間：${feature.properties.close_datetime.slice(0,19).replace('-','/').replace('T',' ') || '-'}</h6>
				</div>
			`)
		}
	})
	// Iterate through each point and add a buffer
	road_break_emis.forEach((el) => {
		let buffered = turf.buffer(el, 50, {units:'meters'});
		el.properties.buffered = buffered;
	});
	overlay_dataset['EMIS道路封閉'] = L.geoJSON(road_break_emis, {
		pointToLayer: (feature, latlng) => {
			const icon = L.icon({
				iconUrl: "marker_icon/road_break_emis.png",
				iconSize: [30, 30],
				iconAnchor: [0, 0], 
				popupAnchor: [10, 10],
			})
			return L.marker(latlng, { icon })
		},
		onEachFeature: (feature, layer) => {
			layer.bindPopup('<div id="traffic_event_div">資料連結中...</div><div id="event_div_chart"></div>')
			layer.on('click', onClick);

			function onClick(e) {
				map.setView([e.latlng.lat, e.latlng.lng]);
				var this_marker = e.target;
				var trigger_method;
				isiOS ? ( (trigger_method = "mouseover") ) : ( (trigger_method = "click"));
				setTimeout(function(){
					map.panBy([-180, -180]);
					var url = publicPath + '/napi/emis/event?project_id=' + this_marker.feature.properties.PRJ_ID + '&disa_no=' + this_marker.feature.properties.DISA_NO + '&type=' + this_marker.feature.properties.project_id_type;
					var this_event = ajax_call(url);
					var data_DM0302 = ajax_call(publicPath + '/napi/emis/treatment_condition?prj_id=' + this_marker.feature.properties.PRJ_ID + '&disa_no=' + this_marker.feature.properties.DISA_NO + '&type=' + this_marker.feature.properties.project_id_type);
					var data_DM0303 = ajax_call(publicPath + '/napi/emis/treatment_history?prj_id=' + this_marker.feature.properties.PRJ_ID + '&disa_no=' + this_marker.feature.properties.DISA_NO + '&type=' + this_marker.feature.properties.project_id_type);
					var data_DM0302_html = overall_case_status(data_DM0302, data_DM0303[(data_DM0303.length)-1]);
					var pic_data = ajax_call(publicPath + '/napi/emis/eventpic?prj_id=' + this_marker.feature.properties.PRJ_ID + "&disa_no=" + this_marker.feature.properties.DISA_NO);
					var pic_trig_dom = "";
					if (pic_data.length == 0) {
						pic_trig_dom = '<button type="button" class="btn btn-secondary btn-sm" id="case_pic_trig"><i class="far fa-images mr-2"></i>現場影像對照</button>'
					} else {
						pic_trig_dom = '<button type="button" class="btn btn-danger btn-sm" id="case_pic_trig"><i class="far fa-images mr-2"></i>現場影像對照</button>'
					}
					var report_from_source = this_event[0].DISA_FROM;
					if (report_from_source != "119轉入") { report_from_source = condition_who(report_from_source) };
					$('#traffic_event_div').html(
						'<h5 class="font-weight-bold">行政區：' + condition_area(this_event[0].TID) + '</h5>' + 
						'<h6 class="float-right">案件編號：' + this_event[0].DISA_NO + '</h6>' +
						'<h6>通報時間：' + timeConverter(this_event[0].RPT_TIME)  + '</h6>' + 
						'<h6>案件敘述：' + this_event[0].SITUATION + '</h6>' +
						'<h6>地址：' + this_event[0].DISA_LOCATION + '</h6>' + 
						'<h6 class="float-right">處理狀態：' + condition_status_type(this_event[0].STATUS) + '</h6>' +
						'<h6>嚴重程度：' + condition_disa_level_component(this_event[0].DISA_LEVEL) + '</h6>' + 
						'<h6>通報來源：' + report_from_source + '</h6>' +
						'<h6>災害類型：' + condition_disa_type(this_event[0].DISA_TYPE) + '</h6>' +
						'<div class="btn-group mb-5p" role="group">'+
							pic_trig_dom +
							'<button type="button" class="btn btn-warning btn-sm" id="case_timeline_trig"><i class="fas fa-forward mr-2"></i>案件處理歷程</button>'+
						'</div>'+
						'<div class="mt-1 mb-1 border-bottom"></div>'+
						data_DM0302_html
					);
					
					$("#case_pic_trig").on(trigger_method, function(){
						var pic_html_string = ""
						if (pic_data.length != 0) {
							var pic_key_name = ["UNFILENAME", "UNFILENAME2", "UNFILENAME3", "UNFILENAME4"]
							var pic_url_array = []
							pic_key_name.forEach(eachKey => {
								if (pic_data[0][eachKey]) {
									pic_url_array.push('https://eoc2.ntpc.gov.tw/Common//Load.ashx?p=' + pic_data[0]["PRJ_ID"] + '&d=' + pic_data[0]["DISA_NO"] + '&f=' + pic_data[0][eachKey])
								}
							})
							pic_html_string = event_pic_carousel(pic_url_array)
							pic_html_string =	
								'<div class="col-6 text-center">'+
									'<h5>現場災情影像</h5>'+
									pic_html_string +
								'</div>'
						}
						pointCctvModalMap(
							'案件編號' + this_marker.feature.properties.DISA_NO + '多元災情影像', 
							pic_html_string, 
							this_marker,
							"limit"
						)
					})
		
					$("#case_timeline_trig").on(trigger_method, function(){
						var html_string = '', 
							html_string_first = '',
							html_string_body = '',
							pic_key_name = ["FILENAME", "FILENAME1", "FILENAME2", "FILENAME3", "FILENAME4"]
						data_DM0302.forEach(function(element){
							html_string_first += '<i class="fas fa-circle text-'  + condition_DM0302_status_color(element.STATUS)[0] + '"></i>' + condition_who(element.DISP_DEPT) +　'：'　+　condition_DM0302_status(element.STATUS) + '&nbsp&nbsp&nbsp'
						});
						var title = '<li><div class="timeline-badge"><i class="fas fa-stopwatch"></i></div><div class="timeline-panel"><div class="timeline-heading"><h4 class="timeline-title font-weight-bold">案件開始受理</h4><p><small class="text-muted"><i class="far fa-clock"></i>' + timeConverter(this_event[0].RPT_TIME) + '</small></p></div><div class="timeline-body"><h5>' + html_string_first + '</h5></div></div></li>';
						data_DM0303.forEach(function(element){
							var pic_url_array = []
							pic_key_name.forEach(eachKey => {
								if (element[eachKey]) {
									try {
										var thisFileNameArray = element[eachKey].split(',')
										thisFileNameArray.forEach(eachPicName => {
											if (eachPicName !== "") {
												pic_url_array.push(`https://eoc2.ntpc.gov.tw/Common/DL.ashx?PRJ_ID=${element.PRJ_ID}&DISA_NO=${element.DISA_NO}&DISP_DEPT=${String(element.DISP_DEPT).slice(0,3)}&FILENAME=${eachPicName}`)
											}
										})
									} catch(e) {}
								}
							})
							if (pic_url_array.length === 0) {
								html_string_body = `<h5>${element.PROCESS}</h5>`
							} else {
								html_string_body = `
									<div class="row">
										<div class="col-4"><h5>${element.PROCESS}</h5></div>
										<div class="col-8">${event_pic_carousel(pic_url_array)}</div>
									</div>`
							}
							html_string += `
								<li>
									<div class="timeline-badge ${condition_DM0302_status_color(element.STATUS)[1]}"></div>
									<div class="timeline-panel">
										<div class="timeline-heading">
											<h4 class="timeline-title font-weight-bold">${condition_who(element.DISP_DEPT, element.REP_NAME)}</h4>
											<p>
												<small class="text-muted"><i class="far fa-clock"></i>${timeConverter(element.REP_TIME)}</small>
											</p>
										</div>
									<div class="timeline-body">
										${html_string_body}
									</div>
								</div>
							</li>`
						});
						modal_open('<div class="container"><ul class="timeline">' + title + html_string + '</ul></div>', '案件編號第' + this_event[0].DISA_NO + '筆-時序列處理回覆查看');
					});
				}, 1000);
			}
		}
	})
	// add layer to map
	map.addLayer(overlay_dataset['公路局道路封閉'])
	map.addLayer(overlay_dataset['EMIC道路封閉'])
	map.addLayer(overlay_dataset['EMIS道路封閉'])
	// add layer's legends
	$("#legend_div_container").html(`
		<div class="legend_text">公路局道路封閉<br><img src="marker_icon/road_break_ncdr.png" width="32"></div>
		<div class="legend_text">EMIS道路封閉<br><img src="marker_icon/road_break_emis.png" width="32"></div>
		<div class="legend_text">EMIC道路封閉<br><img src="marker_icon/road_break_emic.png" width="32"></div>
		<div class="legend_text">建議路線<br><img src="marker_icon/line_blue.png" width="32"></div>
	`)
	// delete previous route & end-points layer
	if (overlay_dataset['一鍵通路線圖層']) map.removeLayer(overlay_dataset['一鍵通路線圖層'])
	if (overlay_dataset['路線起終點圖層']) map.removeLayer(overlay_dataset['路線起終點圖層'])

	// 點擊表格，找到地圖上的點位並zoom in
	let coor_thb = {}, coor_emic = {}, coor_emis = {}
	road_break_thb_geojson.forEach(el => {
		let lat = parseFloat(el.geometry.coordinates[Math.floor(el.geometry.coordinates.length/2)][1]);
		let lng = parseFloat(el.geometry.coordinates[Math.floor(el.geometry.coordinates.length/2)][0]);
		coor_thb[el.properties.info.table.tr[5].td[1].slice(6)] = [lat, lng]
	})
	$("#road-break-thb-table").on("click", "tr", function(){
		var target_coor_thb = coor_thb[$(this).find("td").eq(2).html()];
		map.setView(target_coor_thb, 13);
	});
	road_break_emic_geojson.forEach(el => {
		let lat = parseFloat(el.geometry.coordinates[1]);
		let lng = parseFloat(el.geometry.coordinates[0]);
		coor_emic[el.properties.linecode] = [lat, lng]
	})
	$("#road-break-emic-table").on("click", "tr", function(){
		var target_coor_emic = coor_emic[$(this).find("td").eq(3).html()];
		map.setView(target_coor_emic, 16);
	});
	road_break_emis.forEach(el => {
		let lat = parseFloat(el.geometry.coordinates[1]);
		let lng = parseFloat(el.geometry.coordinates[0]);
		coor_emis[el.properties.DISA_LOCATION] = [lat, lng]
	})
	$("#road-break-emis-table").on("click", "tr", function(){
		var target_coor_emis = coor_emis[$(this).find("td").eq(3).html()];
		map.setView(target_coor_emis, 16);
	});

	// 路線選項圖層
	// const routes_data_geojson = routes_data.map(el => {
	// 	return {
	// 	    "type": "Feature",
	// 	    "geometry": JSON.parse(el.geo ?? ''),
	// 	    "properties": el
	// 	}
	// })

	// 路線選項選單
	// 填入起始縣市選項
	const start_cities = [...new Set(routes_data.map(el => el.county))]
	const start_city_options = start_cities.map(el => `<option value="${el}">${el}</option>`)
	$('#start-city').html('<option value="default-start-city" disabled selected>選擇起始縣市</option>' + start_city_options.join())
	
	// 路線選項 render function
	const showRouteAdvice = () => {
		if (overlay_dataset['一鍵通路線圖層']) map.removeLayer(overlay_dataset['一鍵通路線圖層'])
		if (overlay_dataset['路線起終點圖層']) map.removeLayer(overlay_dataset['路線起終點圖層'])
		// 
		// const routes = routes_data.filter(el => el.start == $('#start-point').val()).sort((a,b) => a.priority - b.priority)
		const routes = ajax_call(publicPath + `/napi/click1map/route?start=${$('#start-point').val()}`);
		let recommended_route = null
		for (let route of routes) {
			let intersects = false;
			let lineString = {
				"type": "Feature",
				"geometry": {
					"type": "LineString",
					"coordinates": JSON.parse(route.geo).coordinates[0]
				},
				"properties": {
					"name": "LineString"
				}
			};
			for (let el of road_break_emis.concat(road_break_thb_geojson).concat(road_break_emic_geojson)) {
				if (turf.lineIntersect(lineString, turf.polygonToLine(el.properties.buffered)).features.length > 0) {
					intersects = true;
					break
				}
			}
			if (!intersects) {
				recommended_route = routes.find(el => el.priority == route.priority)
				break
			}
		}
		if (recommended_route == null) { 
			$('#topic-earthquake-route-advice').html('<h5>無推薦之道路!!</h5>')
		} else {
			$('#topic-earthquake-route-advice').html(
				`<div class="m-3 p-2 d-flex justify-content-between bg-light pe-auto"
					style="cursor:pointer; border: 1px black solid">
					<div style="width:300px">
						<div class="mb-3">路線名稱：${recommended_route.lnname}</div>
						<div>
							<i id="copy-route-url" class="fas fa-copy" title="複製連結"></i>
							<span>路線連結：</span>
							<a id="route-url" href="${recommended_route.ref}" target="_blank">${recommended_route.ref}</a>
						</div>
					</div>
					<div id="route-qrcode" style="width:60px" title="複製QR Code"></div>
				</div>`)
			$('#route-qrcode').qrcode({width: 60, height: 60, text: recommended_route.ref})
			// 點擊複製url功能
			$('#copy-route-url').tooltip().click(() => {
				navigator.clipboard.writeText($('route-url').text())
				toast_open("已成功複製連結至剪貼簿！")
			})
			// 點擊複製qrcode功能
			$('#route-qrcode').tooltip().click(() => {
				let canvas = $('#route-qrcode').children()[0]
				canvas.toBlob((blob) => { 
					const item = new ClipboardItem({ "image/png": blob });
					navigator.clipboard.write([item]); 
				})
				toast_open("已成功複製QR Code至剪貼簿！")
			})

			// 推薦路線圖層製作
			let recommended_route_geojson =  {
				"type": "Feature",
				"geometry": JSON.parse(recommended_route.geo),
				"properties": recommended_route
			}
			overlay_dataset['一鍵通路線圖層'] = L.geoJSON(recommended_route_geojson, {
				style: { color: 'blue', weight: 5 },
			})
			map.addLayer(overlay_dataset['一鍵通路線圖層'])

			// 起終點圖層製作
			const route_points = recommended_route_geojson.geometry.coordinates[0]
			const start_end_point = [
				{
					"type": "Feature",
					"geometry": {
						type: "Point",
						coordinates: route_points[0]
					},
					"properties": { title: '起點', name: $('#start-point').val()}
				},
				{
					"type": "Feature",
					"geometry": {
						type: "Point",
						coordinates: route_points[route_points.length - 1]
					},
					"properties": { title: '終點', name: $('#end-point').val()}
				},
			]
			overlay_dataset['路線起終點圖層'] = L.geoJSON(start_end_point, {
				pointToLayer: (feature, latlng) => {
					var style = {
						radius: 8,
						color: 'blue',
						weight: 3,
						fillColor: '#ff0000',
						fillOpacity: 1,
					}
					return L.circleMarker(latlng, style)
				},
				onEachFeature: (feature, layer) => {
					layer.bindTooltip(feature.properties.title, {
						sticky: true,
						opacity: 1,
						permanent: true, 
					})
				}
			})
			map.addLayer(overlay_dataset['路線起終點圖層'])
		}		
	}

	// 起始縣市變動 > 填入起始地點選項並預設選取第一項、填入對應目標地點
	$('#start-city').change(() => {
		const start_points = [...new Set(routes_data.filter(el => el.county == $('#start-city').val()).map(el => el.start))]
		const start_point_options = start_points.map(el => `<option value="${el}">${el}</option>`)
		$('#start-point').html(start_point_options.join())
		const end_point = routes_data.find(el => el.start == $('#start-point').val()).end
		$('#end-point').html(`<option value="${end_point}">${end_point}</option>`)
		// render 推薦路線+路線圖層+起終點圖層
		showRouteAdvice()
	})

	// 起始地點變動 > 填入對應目標地點
	$('#start-point').change(() => {
		const end_point = routes_data.find(el => el.start == $('#start-point').val()).end
		$('#end-point').html(`<option value="${end_point}">${end_point}</option>`)
		// render 推薦路線+路線圖層+起終點圖層
		showRouteAdvice()
	})
}